import { render, staticRenderFns } from "./IRPFInput.vue?vue&type=template&id=0432b104&"
import script from "./IRPFInput.vue?vue&type=script&lang=js&"
export * from "./IRPFInput.vue?vue&type=script&lang=js&"
import style0 from "./IRPFInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports